// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

input[type="date"]::-webkit-calendar-picker-indicator {
  font-size: 15px;
  cursor: pointer;
}

input[type="time"]::-webkit-calendar-picker-indicator {
  font-size: 15px;
  cursor: pointer;
}

select option:hover {
  cursor: pointer;
}

.dropdown-menu.show {
  width: 250px !important
}

.form-check-input-box {
  border: 1px solid #e9ecef;
  position: relative;
  /* background-color: rgba(58,65,111,.1); */
  height: 1.25em;
  background-image: linear-gradient(310deg, #7928ca, #ff0080) !important;

}


footer.footer {
  background: #fff;
  font-size: 0.875rem;
  border-top: 0;
  padding: 1.25rem 0;
  box-shadow: 0px 10px 10px 20px rgba(176, 184, 214, 0.09), 10px 10px 15px -5px rgb(176, 184, 214);
  color: black;
  font-size: 14px;

  width: 100%;
  margin: 0 auto;
}

.navbar-vertical.navbar-expand-xs.fixed-start {
  left: 0;
  background-color: #FFFFFF;
}




.navbar-vertical .navbar-nav>.nav-item .nav-link.active {
  color: #800000;
  background-color: #E5E4E2;

}




@media only screen and (max-width: 900px) {
  .navbar {
    float: right;
  }

}

.banner_font_size{
  font-size: 1.10rem !important;
}


.css-13cymwt-control{
  max-height: 70px;        
  overflow-y: auto;         
  flex-wrap: wrap !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;EACd,sEAAsE;;AAExE;;;AAGA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gGAAgG;EAChG,YAAY;EACZ,eAAe;;EAEf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,yBAAyB;AAC3B;;;;;AAKA;EACE,cAAc;EACd,yBAAyB;;AAE3B;;;;;AAKA;EACE;IACE,YAAY;EACd;;AAEF;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n  font-size: 15px;\n  cursor: pointer;\n}\n\ninput[type=\"time\"]::-webkit-calendar-picker-indicator {\n  font-size: 15px;\n  cursor: pointer;\n}\n\nselect option:hover {\n  cursor: pointer;\n}\n\n.dropdown-menu.show {\n  width: 250px !important\n}\n\n.form-check-input-box {\n  border: 1px solid #e9ecef;\n  position: relative;\n  /* background-color: rgba(58,65,111,.1); */\n  height: 1.25em;\n  background-image: linear-gradient(310deg, #7928ca, #ff0080) !important;\n\n}\n\n\nfooter.footer {\n  background: #fff;\n  font-size: 0.875rem;\n  border-top: 0;\n  padding: 1.25rem 0;\n  box-shadow: 0px 10px 10px 20px rgba(176, 184, 214, 0.09), 10px 10px 15px -5px rgb(176, 184, 214);\n  color: black;\n  font-size: 14px;\n\n  width: 100%;\n  margin: 0 auto;\n}\n\n.navbar-vertical.navbar-expand-xs.fixed-start {\n  left: 0;\n  background-color: #FFFFFF;\n}\n\n\n\n\n.navbar-vertical .navbar-nav>.nav-item .nav-link.active {\n  color: #800000;\n  background-color: #E5E4E2;\n\n}\n\n\n\n\n@media only screen and (max-width: 900px) {\n  .navbar {\n    float: right;\n  }\n\n}\n\n.banner_font_size{\n  font-size: 1.10rem !important;\n}\n\n\n.css-13cymwt-control{\n  max-height: 70px;        \n  overflow-y: auto;         \n  flex-wrap: wrap !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
